export const text_all_qpt = [
    // {
    //     Xpos_img: 670,
    //     Ypos_img: 17,
    //     width_img: 100,
    //     img: 'bandge',
    // }
]

// not_showing: 'none'
// not_showing: [2, 3]

export const reportnumber_all_qpt = [
    {
        not_showing: 'none',
        Xpos_img: 20,
        Ypos_img: 15,
        fontWeight: 400,
        fontSize: '15px',
    }
]

export const reportnumber_all_9P = [
    {
        not_showing: 'none',
        Xpos_img: 20,
        Ypos_img: 15,
        fontWeight: 400,
        fontSize: '15px',
    }
]

export const reportnumber_all_allergy = [
    {
        not_showing: 'none',
        Xpos_img: 20,
        Ypos_img: 15,
        fontWeight: 400,
        fontSize: '15px',
    }
]

export const reportnumber_all_allergy_kids = [
    {
        not_showing: 'none',
        Xpos_img: 20,
        Ypos_img: 15,
        fontWeight: 400,
        fontSize: '15px',
    }
]

export const reportnumber_all_toxin = [
    {
        not_showing: 'none',
        Xpos_img: 20,
        Ypos_img: 15,
        fontWeight: 400,
        fontSize: '15px',
    }
]

export const reportnumber_all_oms = [
    {
        not_showing: 'none',
        Xpos_img: 20,
        Ypos_img: 15,
        fontWeight: 400,
        fontSize: '15px',
    }
]